import ka from '../../images/flags/georgia.png';
import en from '../../images/flags/united-states.png';
import { useLocation } from "react-router-dom";
import { useDetectLanguage } from "../helpers/language-detector";

export default function LanguageSwitcher() {
    const lang = useDetectLanguage();
    const location = useLocation();

    const changeLanguage = (newLang) => {
        const params = new URLSearchParams(location.search);
        params.set("lang", newLang);

        // Hard redirect – no React re-render, no flicker
        window.location.href = `${location.pathname}?${params.toString()}`;
    };

    return (
        <>
            {lang === "en" ? (
                <img
                    src={ka}
                    alt="KA"
                    onClick={() => changeLanguage("ka")}
                    style={{ cursor: "pointer" }}
                />
            ) : (
                <img
                    src={en}
                    alt="EN"
                    onClick={() => changeLanguage("en")}
                    style={{ cursor: "pointer" }}
                />
            )}
        </>
    );
}
